import { IBlockWrapperProps } from './interface'

const props: IBlockWrapperProps = {
  name: 'blockWrapper',
}

export default props
